import * as React from 'react';
import tombacIcon from '../tombacIcon';

function SvgShareLink(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="4 -4 16 24" {...props}>
      <path
        d="M13.273 6.377c.37.328.407.896.083 1.268a.886.886 0 01-1.177.147l-.081-.064a1.773 1.773 0 00-2.435.083l-3.358 3.325c-.696.7-.696 1.84 0 2.54a1.772 1.772 0 002.52 0l1.684-1.684a.886.886 0 011.26 0 .901.901 0 010 1.27l-1.683 1.685a3.545 3.545 0 01-5.04.002l-.002-.001-.122-.13a3.614 3.614 0 01.122-4.953l3.358-3.326a3.546 3.546 0 014.87-.162zm5.682-5.326l.123.13a3.614 3.614 0 01-.122 4.954l-3.782 3.813a3.546 3.546 0 01-4.87.16.904.904 0 01-.083-1.266.886.886 0 011.176-.147l.082.064c.703.62 1.77.588 2.435-.083l3.78-3.811a1.807 1.807 0 000-2.542 1.772 1.772 0 00-2.52 0l-1.683 1.685a.886.886 0 01-1.26 0 .903.903 0 010-1.27l1.683-1.685a3.545 3.545 0 015.04-.002z"
        fill="currentColor"
      />
    </svg>
  );
}

export default tombacIcon('ShareLink')(SvgShareLink);
